import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import { NavigationProvider } from "./context/NavigationContext"
import { CalculatorProvider } from "./context/CalculatorContext"
import "./styles/Layout.module.css"
import "./styles/global.css"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

root.render(
  <React.StrictMode>
    <NavigationProvider>
      <CalculatorProvider>
        <App />
      </CalculatorProvider>
    </NavigationProvider>
  </React.StrictMode>,
)
